import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { PHONE_TEL } from "@/data/content";

export const MobileBar = () => (
  <div
    className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-2 border-t border-[#2B9FD7]/20 bg-[#090D10]/95 p-3 backdrop-blur-xl lg:hidden"
    data-testid="mobile-conversion-bar"
  >
    <a
      href={PHONE_TEL}
      className="flex items-center justify-center gap-2 rounded-full border border-[#62C3F0]/40 py-3 font-heading text-sm font-semibold text-[#F5F7F9]"
      data-testid="mobile-bar-call"
    >
      <Phone size={16} className="text-[#62C3F0]" /> Bel direct
    </a>
    <Link
      to="/offerte"
      className="flex items-center justify-center gap-2 rounded-full bg-[#2B9FD7] py-3 font-heading text-sm font-semibold text-[#090D10]"
      data-testid="mobile-bar-quote"
    >
      <FileText size={16} /> Offerte aanvragen
    </Link>
  </div>
);
